var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page centered-container",attrs:{"id":"ar-companion-success-page"}},[_c('h1',{staticClass:"standard-heading companion-success"},[_vm._v("Go back to your Companion App")])])
}]

export { render, staticRenderFns }